<template>
  <div class="rfq-wrapper zhenyun-theme">
    <div class="breadcrumb-box">
      <a class="breadcrumb1" @click="$router.push({ path: '/partner/quote' })"
        >我的报价</a
      >
      <span class="separator"> > </span>
      <span class="breadcrumb2"> {{ breadcrumbType }}报价 </span>
    </div>
    <div class="rfq-card" v-loading="fullPageLoading">
      <div class="rfq-card-header">
        <div class="left">
          <h2>{{ breadcrumbType }}报价单 - 询盘编号#{{ rfqForm.rfqId }}</h2>
          <p class="rfq-endtime">{{ formatRemainingTime(rfqForm.endTime) }}</p>
        </div>
        <div class="right">
          <el-button @click="handleCancel">取消</el-button>
          <el-button
            type="primary"
            plain
            @click="handleSubmitQuoteOrder('1')"
            :loading="saveLoading"
            >保存报价</el-button
          >
          <el-button
            type="primary"
            @click="handleSubmitQuoteOrder('2')"
            :loading="submitLoading"
            >提交报价</el-button
          >
        </div>
      </div>
      <div class="rfq-card-content">
        <div class="form-box">
          <el-form
            ref="rfqFormRef"
            :model="rfqForm"
            label-width="166px"
            label-position="left"
            :hide-required-asterisk="true"
          >
            <el-form-item label="采购商">
              <p style="display: flex; align-items: center">
                <img
                  :src="rfqForm.flagPath"
                  alt=""
                  style="margin-right: 8px; vertical-align: middle"
                  v-if="rfqForm.flagPath"
                />
                <el-link
                  :underline="false"
                  class="brand-a"
                  type="primary"
                  @click="jump"
                >
                  {{ rfqForm.buyerCnName }}</el-link
                >
              </p>
            </el-form-item>
            <el-form-item
              prop="validDate"
              :rules="[{ required: true, message: '请选择日期' }]"
            >
              <template slot="label">
                <span>报价有效期</span>
                <span class="red-text">*</span>
              </template>
              <el-date-picker
                v-model="rfqForm.validDate"
                type="date"
                placeholder="选择日期"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="报价货币">
              {{ rfqForm.currencyStr || '--' }}
            </el-form-item>
            <el-form-item
              prop="paymentTerm"
              :rules="[
                { required: !rfqForm.acceptPaymentTerm, message: '请选择' },
              ]"
            >
              <template slot="label">
                <span>付款条款</span>
                <span class="red-text">*</span>
              </template>
              <el-select
                v-model="rfqForm.paymentTerm"
                placeholder="请选择"
                style="width: 220px"
                clearable
                :disabled="rfqForm.acceptPaymentTerm ? true : false"
              >
                <el-option
                  :label="item.label"
                  :value="item.value"
                  v-for="(item, index) in paymentList"
                  :key="index"
                >
                </el-option>
              </el-select>
              <el-checkbox
                v-model="rfqForm.acceptPaymentTerm"
                style="margin-left: 24px"
                @change="changeAcceptPaymentTerm"
                >同意采购商定义的支付方式</el-checkbox
              >
            </el-form-item>
            <el-form-item v-if="rfqForm.paymentTerm == 8" prop="paymentOwn">
              <template slot="label">
                <span>条款内容</span>
              </template>
              <el-input
                v-model="rfqForm.paymentOwn"
                :disabled="rfqForm.acceptPaymentTerm ? true : false"
                style="width: 220px"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="货运条款">
              {{ rfqForm.freightStr }}
            </el-form-item>
            <el-form-item label="交货地址">
              <p v-if="rfqForm.freightAddrVo">
                <span v-if="rfqForm.freightAddrVo.id">
                  {{ address(rfqForm.freightAddrVo) }}
                  <span>&nbsp;{{ rfqForm.freightAddrVo.postCode }}</span>
                </span>
                <span v-else>--</span>
              </p>
              <span v-else>--</span>
            </el-form-item>
            <el-form-item label="报价说明">
              <div>
                <el-input
                  type="textarea"
                  style="width: 562px"
                  maxlength="250"
                  placeholder="请输入"
                  v-model="rfqForm.remark"
                ></el-input>
                <p class="area-max-length">{{ rfqForm.remark.length }}/250</p>
              </div>
            </el-form-item>
            <el-form-item label="报价附件">
              <el-upload
                class="upload-demo"
                ref="upload"
                :action="onlineUrl + '/mk-rfq-api/common/attach/upload'"
                :data="paramsupload"
                :withCredentials="true"
                :show-file-list="false"
                :before-upload="beforeUpload"
                :on-error="handleError"
                :on-success="handleSuccess"
                :accept="'.slddrw,.sldprt,.sldasm,.prt,.eprt,.asm,.dxf,.dwg,.x_t,.igs,.iges,.step,.stp,.stl,.ipt,.iam,.idb,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.zip,.rar,.7z,.pdf,.jpg,.gif,.jpeg,.bmp,.png,.txt,.csv'"
                :multiple="false"
                :file-list="fileList"
              >
                <p class="new-value loading-flex">
                  <span style="color: #0863ff">
                    <i class="iconfont icon-upload1">
                    </i>
                    上传附件
                  </span>
                  <i class="el-icon-loading" v-show="uploadLoading"></i>
                </p>
              </el-upload>
              <div
                class="file-list-show-box"
                v-if="rfqForm.attachList?.length > 0"
              >
                <p
                  class="file-item"
                  style="color: #0863ff"
                  v-for="(fileItem, fileIndex) in rfqForm.attachList"
                  :key="fileIndex"
                >
                  <i
                    class="iconfont icon-attach"
                    style="font-size: 14px; margin-right: 4px"
                  ></i>
                  <a @click="handleDowload(fileItem)">{{ fileItem.name }}</a>
                  <i
                    class="el-icon-close file-close-icon"
                    @click="handleRemove(fileIndex)"
                  ></i>
                </p>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <!-- 零件信息 -->
        <div class="part-info">
          <div class="part-info-title">零件信息</div>
          <div class="part-info-content">
            <partTableInfo
              :part-info-list="rfqForm.parts"
              :detail-info="rfqForm"
              ref="partTableInfoRef"
            ></partTableInfo>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import partTableInfo from './components/part-table-info.vue'
import {
  getInitQuoteInfoApi,
  saveQuoteOrderApi,
  getMyQuoteDetailApi,
} from '@/utils/api/zhenyun.js'
import { getSingleDictByType } from '@/utils/api/common.js'
import moment from 'moment'
import { mapActions } from 'vuex'
import { fileUrl, onlineUrl, companyLogoUrl } from '@/utils/config.js'
export default {
  props: [],
  data() {
    return {
      fileUrl: fileUrl,
      paramsupload: {
        source: 6,
        dir: 1,
        isCreateThumbnail: false,
      },
      fileList: [],
      onlineUrl: onlineUrl,
      companyLogoUrl: companyLogoUrl,
      uploadLoading: false,
      nextName: '',
      saveLoading: false,
      rfqForm: {
        acceptPaymentTerm: true,
        validDate: '',
        paymentTerm: '',
        endTime: '',
        remark: '',
        attachList: [],
        paymentOwn: '',
        // device:'pc'
      },
      paymentList: [],
      isDataChanged: false,
      submitLoading: false,
      initialFormData: {},
      quoteDetailInfo: {},
      fullPageLoading: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
    }
  },
  components: {
    partTableInfo,
  },
  methods: {
    ...mapActions('zhenyunStore', ['getZhenyunLevelLength']),
    jump() {
      window.open(
        `${onlineUrl}/comp/supplier/view-encrypt-buyer-profile/${this.rfqForm.buyerAesId}`,
        '_blank'
      )
    },
    beforeUpload(file) {
      this.uploadLoading = true
      // 1. 定义允许的文件类型
      const allowedTypes = [
        'slddrw',
        'sldprt',
        'sldasm',
        'prt',
        'eprt',
        'asm',
        'dxf',
        'dwg',
        'x_t',
        'igs',
        'iges',
        'step',
        'stp',
        'stl',
        'ipt',
        'iam',
        'idb',
        'doc',
        'docx',
        'xls',
        'xlsx',
        'ppt',
        'pptx',
        'zip',
        'rar',
        '7z',
        'pdf',
        'jpg',
        'gif',
        'jpeg',
        'bmp',
        'png',
        'txt',
        'csv',
      ]
      // 2. 检查文件类型
      const extension = file.name.split('.').pop().toLowerCase()
      const isValidType = allowedTypes.includes(extension)

      if (!isValidType) {
        this.$message.error(`不支持文件类型${extension}`)
        return false
      }

      // 3. 检查文件大小 (25MB限制)
      const maxSize = 25 * 1024 * 1024 // 25MB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过25MB!')
        return false
      }
      return true
    },
    handleError() {
      this.$message.error('上传失败，请稍后再试')
      this.uploadLoading = false
    },
    handleSuccess(response, file, fileList) {
      if (response.rspResult.bizCode !== 200) {
        this.$message.error(response.rspResult.message)
      } else if (response.rspResult.bizCode === 200) {
        this.$message.success('上传成功')
        const data = response.data
        this.fileList.push({
          name: file.name,
          ...data,
        })
        this.uploadLoading = false
        this.$set(this.rfqForm, 'attachList', this.fileList)
      }
    },
    handleDowload(item) {
      const a = document.createElement('a')
      a.href = `${onlineUrl}${item.url}`
      a.target = '_blank'
      a.download = item.name || 'download' // 设置下载文件名
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    handleRemove(index) {
      console.log(index, 'index')
      this.fileList.splice(index, 1)
      this.$set(this.rfqForm, 'attachList', this.fileList)
    },
    formatText(text) {
      return text.replace(/\n/g, '<br>')
    },
    changeAcceptPaymentTerm(event) {
      if (event) {
        this.rfqForm.paymentTerm = this.initialFormData.paymentTerm
      }
    },
    address(freightAddrVo) {
      const { stateIdStr, provinceIdStr, cityIdStr, cityId} = freightAddrVo
      return [stateIdStr, provinceIdStr, !cityId ? undefined : cityIdStr].filter(Boolean).join('，')
    },
    initSubmitParams(status, sourceInfoData) {
      const copyObj = JSON.parse(JSON.stringify(sourceInfoData))
      copyObj.parts = undefined
      copyObj.status = status
      copyObj.acceptPaymentTerm = sourceInfoData.acceptPaymentTerm ? 1 : 0
      copyObj.validDate = new Date(sourceInfoData.validDate).valueOf()
      copyObj.rfqId ||= this.$route.params.id
      console.log(sourceInfoData.parts, 'sourceInfoData.parts')
      const initPartParams = sourceInfoData.parts.reduce((result, part) => {
        const transformedItem = {
          itemList: [1, 2, 3, 4, 5].map((type) => {
            const valueKey = type === 5 ? 'partRowTotalNumber' : `num${type}`
            const priceItem = this.$route?.query?.quoteId
              ? part.quotePrice.find((item) => item.itemType === type)
              : {}
            return {
              type,
              ...part.partPriceInfoList.reduce((acc, priceInfo, idx) => {
                acc[`num${idx + 1}`] = priceInfo[valueKey]
                return acc
              }, {}),
              id: priceItem ? priceItem.quoteItemId : null,
            }
          }),
          rfqPartId: part.id || part.rfqPartId,
        }
        result.push(transformedItem)
        return result
      }, [])
      // 在这里整理参数，把多余的参数去掉，只留下必须的参数
      const initPayloadParams = {
        acceptPaymentTerm: copyObj.acceptPaymentTerm,
        validDate: copyObj.validDate,
        paymentTerm: copyObj.paymentTerm,
        remark: copyObj.remark,
        attachList: copyObj.attachList.map((k) => k.hashCode),
        partsList: initPartParams,
        rfqId: copyObj.rfqId,
        status: copyObj.status,
        rfqQuoteId: copyObj.rfqQuoteId,
        status: copyObj.status,
        shippingMethod: copyObj.shippingMethod,
        shippingTerms: copyObj.shippingTerms,
        paymentOwn: copyObj.paymentOwn,
      }
      return initPayloadParams
    },
    async handleSubmitQuoteOrder(status) {
      const [isValid, res] = await Promise.all([
        this.$refs.rfqFormRef.validate(),
        this.$refs.partTableInfoRef.vaildForm(),
      ])
      if (!isValid || !res) {
        return this.$message.error('请完善信息')
      }
      status == '1' ? (this.saveLoading = true) : (this.submitLoading = true)
      const payloadParams = this.initSubmitParams(status, this.rfqForm)
      this.submitQuote(payloadParams)
    },
    async submitQuote(params) {
      try {
        const res = await saveQuoteOrderApi(params)
        this.submitLoading = false
        this.saveLoading = false
        const { rspResult, data } = res
        if (rspResult.bizCode == 5005) {
          this.$message.error('已失效的报价单不能提交')
        } else if (rspResult.bizCode == 5006) {
          this.$message.error('报价已结束')
        } else if (rspResult.bizCode == 200) {
          this.$message.success('操作成功')
          await this.getZhenyunLevelLength()
          this.isDataChanged = false
          this.$router.push({
            name: 'quote-detail',
            params: { id: data.id },
          })
        } else {
          this.$message.error(rspResult.message)
          return false
        }
      } catch (error) {
        this.submitLoading = false
        this.saveLoading = false
      }
    },
    handleCancel() {
      console.log(this.nextName, 'nextName')
      if (this.nextName && this.nextName == 'order-radar-result') {
        this.$router.push('/partner')
      } else {
        this.$router.push('/partner/quote')
      }
    },
    async fetchRfqInfo() {
      try {
        this.fullPageLoading = true
        const res = await getInitQuoteInfoApi({
          rfqId: this.$route.params.id,
        })
        this.fullPageLoading = false
        this.rfqForm = { ...this.rfqForm, ...res.data }
        this.rfqForm.currencySymbol ||= this.rfqForm.symbol
        this.rfqForm.paymentTerm = this.rfqForm.payment
          ? this.rfqForm.payment
          : this.rfqForm.paymentTerm
        // 存储初始数据用于比较
        this.initialFormData = JSON.parse(JSON.stringify(this.rfqForm))
        this.isDataChanged = false
        this.rfqForm.parts = this.rfqForm.parts.map((k) => {
          const quantityFields = ['quoteNum1', 'quoteNum2', 'quoteNum3']
          const existingQuantityFields = quantityFields.filter(
            (field) => k[field]
          )
          return {
            ...k,
            partPriceInfoList: existingQuantityFields.map((field) => ({
              numQuantity: k[field] || 0,
              num1: 0, // 单价
              num2: 0, // 模具费
              num3: 0, // 杂费
              num4: 0, // 运费
            })),
          }
        })
        this.$refs.partTableInfoRef.initFormData(this.rfqForm.parts || [])
        return Promise.resolve()
      } catch (error) {
        this.fullPageLoading = false
      }
    },
    formatRemainingTime(time) {
      const timestamp = moment(time).endOf('day').valueOf()
      const now = new Date().getTime()
      // 如果时间戳已过期
      if (timestamp <= now) {
        return '报价已结束'
      }
      const remainingTime = timestamp - now
      const seconds = Math.floor(remainingTime / 1000)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)
      const years = Math.floor(days / 365)
      const remainingDays = days % 365
      const remainingHours = hours % 24
      // 拼接结果（如果某部分为0，则不显示）
      let result = '可报价（剩余'
      if (years > 0) result += `${years}年`
      if (remainingDays > 0) result += `${remainingDays}天`
      if (remainingHours > 0) result += `${remainingHours}小时`
      result += '结束报价）'
      return result
    },
    async fetchDictPayment() {
      try {
        const res = await getSingleDictByType('payment')
        if (res.rspResult.bizCode == 200) {
          this.paymentList = (res.rspListData.list || []).map((k) => {
            return {
              label: k.name,
              value: k.codeValue,
            }
          })
        }
      } catch (error) {}
    },
    checkDataChanged() {
      const currentFormData = JSON.parse(JSON.stringify(this.rfqForm))
      const isMainFormChanged =
        JSON.stringify(currentFormData) !== JSON.stringify(this.initialFormData)

      // 直接获取子组件数据进行比较
      const currentTableData =
        this.$refs.partTableInfoRef?.getCurrentData() || []
      const initialTableData = this.initialFormData.parts || []
      const isTableDataChanged =
        JSON.stringify(currentTableData) !== JSON.stringify(initialTableData)

      this.isDataChanged = isMainFormChanged || isTableDataChanged
    },
    async fetchQuoteInfo() {
      try {
        this.fullPageLoading = true
        const res = await getMyQuoteDetailApi({
          rfqQuoteId: this.$route.query.quoteId,
        })
        this.fullPageLoading = false
        const { rspResult, data } = res
        if (rspResult.bizCode == 200) {
          this.quoteDetailInfo = data
          this.rfqForm = {
            ...this.rfqForm,
            ...data,
            rfqQuoteId: data.id,
          }
          this.rfqForm.paymentTerm = data.paymentTermsValue
          this.rfqForm.acceptPaymentTerm =
            data.acceptPaymentTerm == 1 ? true : false
          this.rfqForm.paymentOwn = data.paymentTerms
          this.fileList = data.attachments || []
          this.rfqForm.attachList = (data.attachments || []).map((k) => {
            k.name = k.originalName
            return k
          })
          this.rfqForm.parts = data.partsInfos.map((k) => {
            const quantityFields = ['quoteNum1', 'quoteNum2', 'quoteNum3']
            const existingQuantityFields = quantityFields.filter(
              (field) => k[field]
            )
            const quoteLength = Array.from(
              { length: existingQuantityFields.length },
              (_, index) => index + 1
            )
            return {
              ...k,
              partPriceInfoList: quoteLength.map((l) => {
                return {
                  numQuantity: k[`quoteNum${l}`],
                  ...k.quotePrice.reduce((acc, cur, index, thisArr) => {
                    if (1 <= cur.itemType <= 4) {
                      acc[`num${cur.itemType}`] = thisArr[index][`value${l}`]
                    }
                    return acc
                  }, {}),
                }
              }),
            }
          })

          this.$nextTick(() => {
            this.$refs.partTableInfoRef.initFormData(this.rfqForm.parts || [])
          })
        }
      } catch (error) {
        this.fullPageLoading = false
      }
    },
  },
  beforeDestroy() {},
  mounted() {
    this.fetchDictPayment()
    if (this.$route.name == 'update-quote') {
      //修改页面获取详情
      this.fetchRfqInfo().then((res) => {
        this.fetchQuoteInfo()
      })
    } else {
      this.fetchRfqInfo()
    }
    window.addEventListener('beforeunload', this.handleBeforeUnload)
  },
  computed: {
    breadcrumbType() {
      return this.$route.name == 'created-quote' ? '创建' : '修改'
    },
  },
  watch: {
    rfqForm: {
      handler(newVal, oldVal) {
        this.checkDataChanged()
      },
      deep: true,
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.nextName = from.name
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.isDataChanged) {
      this.$confirm('当前数据尚未保存，确定离开报价页面？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          next()
        })
        .catch(() => {
          next(false)
        })
    } else {
      next()
    }
  },
}
</script>

<style scoped lang="scss">
.rfq-wrapper {
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 16px;
  font-family: SourceHanSansCN-Regular;
  .breadcrumb-box {
    padding: 16px 0;
    .breadcrumb1,
    .separator {
      color: #98a3b7;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      cursor: pointer;
    }
    .breadcrumb2 {
      color: #333333;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      cursor: pointer;
    }
    .separator {
      margin: 0 4px;
    }
  }
  .rfq-card {
    width: 100%;
    background-color: #fff;
    padding-bottom: 16px;
    .rfq-card-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 0;
      margin: 0 16px;
      border-bottom: 1px solid #e9edf1;
      position: sticky;
      top: 0;
      z-index: 9;
      background: #fff;
      .left,
      .right {
        display: flex;
        align-items: center;
      }

      h2 {
        margin: 0 !important;
        color: #222222;
        text-align: justify;
        font-family: SourceHanSansCN-Bold;
        font-size: 20px;
        // font-weight: 700;
      }

      .rfq-endtime {
        color: #ff7800;
        text-align: justify;

        font-size: 16px;
        margin-left: 16px;
      }
    }

    .rfq-card-content {
      margin: 16px 16px 0;
      .form-box {
        padding: 8px 24px 0;
        :deep(.el-form-item--small.el-form-item) {
          margin-bottom: 16px !important;
        }

        :deep(.el-form-item--small .el-form-item__label) {
          color: #666666 !important;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
        }

        :deep(.el-form-item--small .el-form-item__content) {
          color: #333333 !important;
          font-size: 14px;
          font-weight: 400;
        }
        .brand-a {
          color: #0863ff;
        }
      }
    }
  }
}

//零件信息
.part-info {
  padding-top: 16px;
  .flex-gap-4 {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  .part-info-title {
    color: #222222;
    font-family: SourceHanSansCN-Bold;
    font-size: 16px;
    margin-bottom: 16px;
    // font-weight: 700;
  }
  .part-info-content {
    border: 1px solid #e9edf1;
  }
  .part-table-list {
    margin-top: 16px;
  }
}
.red-text {
  color: #ff081f;
}
.area-max-length {
  font-size: 12px;
  margin-top: 4px;
  text-align: right;
  width: auto;
  margin-right: 0px;
  color: #666;
  width: 562px;
  line-height: 12px;
}
.value {
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: #333333;
  text-overflow: ellipsis;
  font-family: SourceHanSansCN-Regular;
  font-size: 14px;
  line-height: 22px;
}

.file-item {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.file-item:hover .file-close-icon {
  display: block;
}
.file-close-icon {
  display: none;
  margin-left: 16px;
}
.file-list-show-box {
  display: flex;
  flex-direction: column;
}
</style>
